import React from 'react';
import HighlightFeature, {
  ACTION_STEPS,
  RIGHT,
  ACTION_RESULTS_TABLE,
} from '@/components/HighlightFeature';

export const AddStepsSuggestion: React.FC = () => (
  <HighlightFeature
    position={RIGHT}
    text={
      <div>
        <span>
          Build up your query by adding <b>query steps</b> in the left sidebar
          🚀
        </span>
      </div>
    }
    targetAction={ACTION_STEPS}
    requiredActions={[ACTION_RESULTS_TABLE]}
    delay={500}
    style={{ minWidth: '290px' }}
  />
);
